import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SearchIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Search",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m29.66 27.7-8.36-8.36c1.4-1.8 2.24-4.09 2.24-6.58C23.54 6.82 18.72 2 12.78 2S2.01 6.82 2.01 12.76s4.82 10.76 10.76 10.76c2.49 0 4.78-.84 6.6-2.26l-.02.02 8.34 8.36c.24.22.57.36.92.36.76 0 1.38-.62 1.38-1.38 0-.36-.14-.68-.36-.93s.03 0 .03 0Zm-16.84-6.94c-4.4 0-7.96-3.58-7.96-7.97s3.57-7.97 7.97-7.97 7.97 3.57 7.97 7.97v.03c-.02 4.39-3.59 7.95-7.98 7.95Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M28.14 29.29c-.29 0-.58-.11-.81-.33l-7.58-7.58a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l7.58 7.58a1.14 1.14 0 0 1-.81 1.95"
      }), /*#__PURE__*/_jsx("path", {
        d: "M13.29 24.71c-6.3 0-11.43-5.13-11.43-11.43S6.98 1.86 13.29 1.86s11.43 5.13 11.43 11.43-5.13 11.43-11.43 11.43Zm0-20.57c-5.04 0-9.14 4.1-9.14 9.14s4.1 9.14 9.14 9.14 9.14-4.1 9.14-9.14-4.1-9.14-9.14-9.14"
      })]
    })
  }));
};
SearchIcon.displayName = 'SearchIcon';